import React from "react";
import { Zap, ArrowRight } from "lucide-react";

export default function TopBanner() {
  return (
    <div className="w-full" style={{ background: "#2552ff", color: "white" }}>
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-center gap-3 text-sm">
        <Zap size={16} className="opacity-90" />
        <span className="opacity-95">Somm.ai was selected in Forbes 30 Under 30</span>
        <a
          href="https://www.forbes.com/pictures/61a67d8742bbf7cb5403d8c8/david-kong-29-founder-som/"
          target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-1 font-semibold underline underline-offset-4 hover:opacity-90"
        >
          Read more about it here <ArrowRight size={14} />
        </a>
      </div>
    </div>
  );
}
